import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import IsCompany from '@/pages/IsCompany';
import CompanyForm from '@/pages/CompanyForm';
import PropertyDetails from '@/pages/PropertyDetails';
import Movables from '@/pages/Movables';
import ContractDetails from '@/pages/ContractDetails';
import PackageInformation from '@/pages/PackageInformation';
import Comparison from '@/pages/Comparison';
import ComparingTwoOffers from '@/pages/ComparingTwoOffers';
import NoAccess from '@/pages/NoAccess';
import CalculationRouterView from '@/pages/CalculationRouterView';

/** Contracting */
import ContractingRouterView from '@/pages/ContractingRouterView';
import BaseDataView from '@/pages/Contracting/BaseDataView';
import InsuredDataView from '@/pages/Contracting/InsuredDataView';
import FinancingDataView from '@/pages/Contracting/FinancingDataView';
import SummaryView from '@/pages/Contracting/SummaryView';
import StatementView from '@/pages/Contracting/StatementView';
import Success from '@/pages/Contracting/Success';
import Error from '@/pages/Contracting/Error';

export default [
	{
		path: '/dijkalkulacio/',
		component: CalculationRouterView,
		children: [
			{ path: '', component: Home, name: 'home' },
			{ path: 'tajekoztato', component: IsCompany, name: 'is-company' },
			{
				path: 'ceges-urlap',
				component: CompanyForm,
				name: 'company-form',
			},
			{
				path: 'ingatlan-adatai',
				component: PropertyDetails,
				name: 'property-details',
				meta: { dataLayerEvent: 'Ingatlan_adatai' },
			},
			{
				path: 'ingosag-adatai',
				component: Movables,
				name: 'movable',
				meta: { dataLayerEvent: 'Ingossag_adatai' },
			},
			{
				path: 'szerzodes-adatai',
				component: ContractDetails,
				name: 'contract-details',
				meta: { dataLayerEvent: 'Szerzodes_adatai' },
			},
			{
				path: 'csomagtajekoztato',
				component: PackageInformation,
				name: 'package-information',
				meta: { dataLayerEvent: 'Csomagtajekoztato' },
			},
			{
				path: 'osszehasonlitas/:hash',
				component: Comparison,
				name: 'comparison',
				meta: { dataLayerEvent: 'Osszehasonlitas' },
			},
			{
				path: 'ajanlatok-osszehasonlitasa/:hash',
				component: ComparingTwoOffers,
				name: 'comparing-two-offers',
			},
			{ path: 'nincs-hozzaferes', component: NoAccess, name: 'no-access' },
		],
	},
	{
		path: '/szerzodes-kotes/:hash/:insurer_uuid',
		component: ContractingRouterView,
		children: [
			{
				path: '/',
				component: BaseDataView,
				name: 'contracting-base',
				meta: {
					title: 'Szerződő adatok',
					desc: 'Kérjük, szíveskedjen kitölteni a szerződés megkötéséhez szükséges további adatokat!<br>A *-gal jelölt mezők kitöltése kötelező!',
					dataLayerEvent: 'Szerzodo_adatai',
				},
			},
			{
				path: 'biztositott-adatok',
				component: InsuredDataView,
				name: 'contracting-insured',
				meta: {
					title: 'Biztosított adatok',
					desc: 'Kérjük, szíveskedjen kitölteni a Biztosítottra vonatkozó adatokat!<br>A *-gal jelölt mezők kitöltése kötelező!',
					dataLayerEvent: 'Biztositott_adatok',
				},
			},
			{
				path: 'finanszirozasi-adatok',
				component: FinancingDataView,
				name: 'contracting-financing',
				meta: {
					title: 'Finanszírozási adatok',
					desc: 'Kérjük, szíveskedjen megadni a finanszírozás adatait!<br>A *-gal jelölt mezők kitöltése kötelező!',
					dataLayerEvent: 'Finanszirozasi_adatok',
				},
			},
			{
				path: 'osszefoglalas',
				component: SummaryView,
				name: 'contracting-summary',
				meta: {
					title: 'Összefoglaló oldal',
					desc: 'Kérjük, szíveskedjen a megadott adatokat ellenőrizni és szükség esetén módosítani azokat. A korábbi képernyőkre visszalépéshez kérjük, kattintson a fenti folyamatjelző sávban a megfelelő oldal nevére.',
					dataLayerEvent: 'Osszefoglalas',
				},
			},
			{
				path: 'nyilatkozatok',
				component: StatementView,
				name: 'contracting-statement',
				meta: {
					title: 'Nyilatkozatok és alkuszi megbízás',
					desc: 'Kérjük, szíveskedjen a szükséges nyilatkozatokat megtenni, az elektronikus PDF dokumentumok tartalmát megismerni és az alkuszi megbízást megadni!',
					dataLayerEvent: 'Nyilatkozatok',
				},
			},
		],
	},
	{
		path: '/szerzodes-kotes/sikeres-rogzites',
		component: Success,
		name: 'contracting-success',
		meta: {
			title: 'Sikeres rögzítés',
			desc: '',
		},
	},
	{
		path: '/szerzodes-kotes/hibas-rogzites',
		component: Error,
		name: 'contracting-error',
		meta: {
			title: 'Valami probléma akadt',
			desc: '',
		},
	},
];
